import { Node, mergeAttributes } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-2'
import Citaat from '@/components/Citaat/Citaat.vue'

export default Node.create({
    name: 'Citaat',
    inline: true,
    group: 'inline',
    content: 'inline*',

    addAttributes() {
        return {
            value: {
                default: "attr string"
            },
            ref: {
                default: ''
            }
        }
    },

    parseHTML() {
        return [
            {
                tag: 'citaat',
            },
        ]
    },

    renderHTML({ HTMLAttributes }) {
        return ['citaat', mergeAttributes(HTMLAttributes)]
    },

    addNodeView() {
        return VueNodeViewRenderer(Citaat)
    },
})